import { FakeLink } from '@/core/FakeLink';
import { sqWorkbenchStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { goToProject } from '@/impactReports/impactReport.utilities';
import { useApiGetProjectQuery } from '@seeqdev/api/endpoint/ProjectsApi';

type SelectedProjectDisplayAndLinkProps = {
  projectId: string;
};

/**
 * Displays the selected Data Lab project name and links to the project in Data Lab.
 */
export const SelectedProjectDisplayAndLink = ({ projectId }: SelectedProjectDisplayAndLinkProps) => {
  const preferNewTab = useFluxPath(sqWorkbenchStore, () => sqWorkbenchStore.preferNewTab);
  const { data: project } = useApiGetProjectQuery({ id: projectId }, { enabled: Boolean(projectId) });

  return (
    <FakeLink onClick={() => goToProject(projectId, preferNewTab)} extraClassNames="truncateWSLink">
      {project?.name ?? ''}
    </FakeLink>
  );
};
